import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { LanguageDispatchTypes } from "../../../models/DispatchTypes/MemberDetails";
import {
  GetLanguageMasterResp,
  getRelationshipMasterResp,
} from "../../../actions/MemberDetails";
import MemberDetails from "../components/memberDetails/MemberDetails";

const mapStateToProps = ({
  languageMasterState,
  TabSessionStorageState,
  relationMasterState,
}: ApplicationState) => ({
  LanguageMasterData: languageMasterState,
  TabSessionStorageData: TabSessionStorageState,
  relationMasterData: relationMasterState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    LanguageDispatchTypes
  >
) => {
  return {
    getLanguageMasterResp: () => {
      dispatch(GetLanguageMasterResp());
    },
    getRelationshipMasterResp: () => {
      dispatch(getRelationshipMasterResp());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberDetails);
